
export default
  name: 'event-results-statistics'
  props:
    data: Object
    dark: {type: Boolean, default: false}
  data: ->
    fields: [
      {key: 'name', label: i18n.t('discipline'), isRowHeader: true},
      {key: 'best', label: i18n.t('shared.event_statistics.best')},
      {key: 'worst', label: i18n.t('shared.event_statistics.worst')},
      {key: 'median', label: i18n.t('shared.event_statistics.median')},
      {
        key: 'total',
        label: "#{i18n.t('shared.event_statistics.count')} (#{@data.statuses['total']})"
      },
      {key: 'q', label: "Q (#{@data.statuses['q']})", headerTitle: i18n.t('statuses.Q')},
      {key: 'hc', label: "HC (#{@data.statuses['hc']})", headerTitle: i18n.t('statuses.HC')},
      {key: 'dnf', label: "DNF (#{@data.statuses['dnf']})", headerTitle: i18n.t('statuses.DNF')},
      {key: 'dsq', label: "DSQ (#{@data.statuses['dsq']})", headerTitle: i18n.t('statuses.DSQ')},
      {key: 'dns', label: "DNS (#{@data.statuses['dns']})", headerTitle: i18n.t('statuses.DNS')},
    ]
  mounted: ->
    @fields = @fields.filter((f) => (!@data.empty_keys.includes(f.key)))

